"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FUTURES_ORDER_FORM_NAME = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderEntryFormConstants = require("../../../../constants/sendOrder/orderEntryFormConstants");
var _kycLevelsSelectors = require("../../../../redux/selectors/kycLevelsSelectors");
var _FuturesOrderEntryAnchoring = _interopRequireDefault(require("./FuturesOrderEntryAnchoring"));
var _orderEntryActions = require("../../../../redux/actions/orderEntryActions");
var _orderFormTypes = require("../../../../constants/sendOrder/orderFormTypes");
var _orderEntrySelector = require("../../../../redux/selectors/orderEntrySelector");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _modalActions = require("../../../../redux/actions/modalActions");
var _futuresSelectors = require("../../../../redux/futures/selectors/futuresSelectors");
var _futuresActions = require("../../../../redux/futures/actions/futuresActions");
var _futuresLeverageSelectors = require("../../../../redux/futures/selectors/futuresLeverageSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FUTURES_ORDER_FORM_NAME = exports.FUTURES_ORDER_FORM_NAME = 'futuresOrderEntry';
var FuturesOrderEntryComponentForm = (0, _reduxForm.reduxForm)({
  form: FUTURES_ORDER_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _orderEntryActions.placeOrderWithChecks)(_orderFormTypes.orderFormTypes["default"], payload, FUTURES_ORDER_FORM_NAME));
  }
})(_FuturesOrderEntryAnchoring["default"]);
var selectorArgs = {
  formName: FUTURES_ORDER_FORM_NAME
};
var mapStateToProps = function mapStateToProps(state) {
  var side = (0, _orderEntrySelector.selectOrderSide)(state, selectorArgs);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var Product1Symbol = selectedInstrument.Product1Symbol;
  var defaultOrderType = _orderEntryFormConstants.futuresOrderFormTypes.market.displayName;
  return {
    initialValues: {
      side: _orderEntryFormConstants.buyValue,
      orderType: defaultOrderType,
      orderByProduct: Product1Symbol,
      quantity: '',
      value: '0',
      limitPrice: '',
      triggerPrice: '',
      triggerPriceType: 'LastPrice',
      price: '',
      priceOrderType: 'Market',
      totalAmount: '0',
      timeInForce: 'GTC',
      tpPriceType: 'LastPrice',
      takeProfit: '',
      slPriceType: 'LastPrice',
      stopLoss: '',
      anchoredField: ''
    },
    futuresOrderTypesOptions: (0, _orderEntrySelector.selectOrderTypes)(state, _orderEntryFormConstants.futuresOrderTypes),
    disableTrading: (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state).disableTrading,
    leverage: (0, _futuresLeverageSelectors.currentFuturesLeverageSelector)(state),
    maxQuantity: (0, _futuresSelectors.futuresAccountMaxQuantitySelector)(state) || 0,
    isBuy: side === _orderEntryFormConstants.buyValue,
    side: side,
    instrumentId: selectedInstrument.InstrumentId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    reduxFormChange: function reduxFormChange(key, val) {
      return dispatch((0, _reduxForm.change)(FUTURES_ORDER_FORM_NAME, key, val));
    },
    openPnLCalculator: function openPnLCalculator() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.FUTURES_PNL_CALCULATOR));
    },
    fetchMaxQuantity: function fetchMaxQuantity(instrumentId, leverageMultiplier) {
      return dispatch((0, _futuresActions.getFuturesMaxQuanity)(instrumentId, leverageMultiplier));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FuturesOrderEntryComponentForm);